import React from 'react'

const ModalHemoderivados = ({setChoiceCirugiaHemoderivados,setModalOnCirugiaHemoderivados}) => {
  const handleCancelarClick = () => {
    setChoiceCirugiaHemoderivados(false)
    setModalOnCirugiaHemoderivados(false)

}
  return (
    <div className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-white"
  id="exampleModalScrollable" tabIndex="-1" aria-labelledby="exampleModalScrollableLabel" aria-hidden="true">
  <div className="sm:h-[calc(100%)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
    <div
      className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
      <div
        className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md">
        <h5 className="text-xl font-medium leading-normal text-gray-800" id="exampleModalScrollableLabel">
          Lista de Selección Maestro de Procedimientos
        </h5>
        <button type="button"
        onClick={handleCancelarClick}
          className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
          data-bs-dismiss="modal" aria-label="Close">X</button>
      </div>
      <div className="flex-auto overflow-y-auto relative px-2">
        <div className="flex py-2 text-left">
            <div className="w-1/3   ">
                                <label  className="form-label inline-block mb-2 text-gray-900 font-medium " >
                                    Código Procedimiento
                                </label>
                                <input
                                    //   onChange={searchUserId}
                                    //defaultValue={props.userDate[0].ProEmpCod}
                                    //defaultValue={dataUser.ProEmpCod}
                                    type="text"
                                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                    id="exampleFormControlInput1"
                                    placeholder=""
                                />
                                </div>
                                <div className='px-1'>
                                <label  className="form-label inline-block mb-2 text-gray-900 font-medium " >
                                    Nombre Proced.
                                </label>
                                <input
                                    //   onChange={searchUserId}
                                    //defaultValue={props.userDate[0].ProEmpCod}
                                    //defaultValue={dataUser.ProEmpCod}
                                    type="text"
                                    className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                                    id="exampleFormControlInput1"
                                    placeholder=""
                                />
                                </div>
                                
                                
              
                            
        </div>
        
        <div className="flex flex-col">
        <div className="overflow-x-auto ">
          <div className="py-4 inline-block min-w-full sm:px-1 ">
            <div className="overflow-hidden">
              <table className="min-w-full text-center bg-gray-200">
                <thead className="border-b ">
                  <tr>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-6 py-4"
                    >
                      Código
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-6 py-4"
                    >
                      Nombre Procedimiento
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-6 py-4"
                    >
                      Cantidad
                    </th>
                    <th
                      scope="col"
                      className="text-sm font-medium text-gray-900 px-6 py-4"
                    >
                      Volumen
                    </th>
                  </tr>
                </thead>
                <tbody>
                  
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      </div>
      <div
        className="flex flex-shrink-0 flex-wrap items-center justify-end p-2 border-t border-gray-200 rounded-b-md">
        <button type="button"
        onClick={handleCancelarClick}
          className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
          data-bs-dismiss="modal">
          Cancelar
        </button>
        <button type="button"
          className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
          Guardar
        </button>
      </div>
    </div>
  </div>
</div>
  )
}

export default ModalHemoderivados